exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-editor blockquote {\n  padding: 10px 20px;;\n  font-size: 17.5px;\n  border-left: 5px solid #f86466;\n  background: white;\n}\n.vue-editor pre {\n  display: block;\n  padding: 9.5px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: #333;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n.editor-body blockquote {\n  margin-bottom: 30px;\n}\n.editor-body pre {\n  margin-bottom: 10px;\n}\n.editor-body ul {\n  padding-left: 40px;\n  list-style-type: disc;\n}\n.editor-body ol {\n  padding-left: 40px;\n}\n.upload{\n  margin-top:10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-570be2c2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1&bustCache!./src/components/utils/vue-editor.vue
// module id = rzA2
// module chunks = 2